import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { Breadcrumb } from '@whitbread-eos/atoms';
import { useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var HotelBreadcrumb = _ref => {
  var openInNewTab = _ref.openInNewTab;
  var _useStaticHotelInform = useStaticHotelInformation(),
    breadcrumb = _useStaticHotelInform.breadcrumb,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    breadcrumbList = _useState2[0],
    setBreadcrumbList = _useState2[1];
  useEffect(() => {
    if (!breadcrumb) {
      return;
    }
    var breadcrumbList = breadcrumb ? breadcrumb.map((breadcrumbData, index) => ({
      name: breadcrumbData.title,
      url: index === breadcrumb.length - 1 ? '#' : breadcrumbData.link,
      isCurrentPage: index === breadcrumb.length - 1
    })) : [];
    setBreadcrumbList(breadcrumbList);
  }, [breadcrumb]);
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error === null || error === void 0 ? void 0 : error.message
    });
  }
  return breadcrumbList.length ? _jsx(Box, _objectSpread(_objectSpread({
    "data-testid": "breadcrumbs-hdp"
  }, breadcrumbBoxStyles), {}, {
    children: _jsx(Breadcrumb, {
      items: breadcrumbList,
      openInNewTab: openInNewTab,
      listProps: {
        flexWrap: 'wrap'
      }
    })
  })) : null;
};
var breadcrumbBoxStyles = {
  mt: 'xl',
  mb: 'xl'
};
export { HotelBreadcrumb };